import { render } from "./AuButton.vue?vue&type=template&id=38731385&scoped=true"
import script from "./AuButton.vue?vue&type=script&lang=js"
export * from "./AuButton.vue?vue&type=script&lang=js"

import "./AuButton.vue?vue&type=style&index=0&id=38731385&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-38731385"]])

export default __exports__